// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { fermentationGroupAlertId } from './FermentationGroupAlert';
import { fermentationId } from './Fermentation';
import { z } from 'zod';
export const fermentationAlertConditionId = (z.number());
export const fermentationAlertCondition = z.object({
    id: fermentationAlertConditionId,
    group_alert_id: fermentationGroupAlertId,
    fermentation_id: fermentationId.nullable(),
    subject: z.string(),
    is_true: z.boolean(),
    since: z.date(),
    last_seen_at: z.date(),
    detail: z.string().nullable(),
    observed_value: z.string().nullable(),
});
export const fermentationAlertConditionInitializer = z.object({
    id: fermentationAlertConditionId.optional(),
    group_alert_id: fermentationGroupAlertId,
    fermentation_id: fermentationId.optional().nullable(),
    subject: z.string().optional(),
    is_true: z.boolean(),
    since: z.date(),
    last_seen_at: z.date().optional(),
    detail: z.string().optional().nullable(),
    observed_value: z.string().optional().nullable(),
});
export const fermentationAlertConditionMutator = z.object({
    id: fermentationAlertConditionId.optional(),
    group_alert_id: fermentationGroupAlertId.optional(),
    fermentation_id: fermentationId.optional().nullable(),
    subject: z.string().optional(),
    is_true: z.boolean().optional(),
    since: z.date().optional(),
    last_seen_at: z.date().optional(),
    detail: z.string().optional().nullable(),
    observed_value: z.string().optional().nullable(),
});
//# sourceMappingURL=FermentationAlertCondition.js.map